type Props = {
  hideCompanySelect?: boolean;
};

export const NarrativeMiniValuatorValuationSkeleton = ({
  hideCompanySelect,
}: Props) => {
  return (
    <section
      className="grid gap-x2 bg-surface-2 p-x2 md:rounded-x1_5"
      role="presentation"
      aria-label="Loading skeleton"
    >
      {!hideCompanySelect && <div className="bones h-x3" />}
      <div className="bones h-x9" />
      <div className="bones h-x10" />
      <div className="bones h-[142px]" />
      <div className="grid grid-cols-[repeat(3,theme(space.x12))] grid-rows-[theme(space.x4)] justify-end gap-x1">
        <div className="bones" />
        <div className="bones" />
        <div className="bones" />
      </div>
    </section>
  );
};
